import React from "react";
import {HashRouter, Redirect, Route, Switch, withRouter, Link} from 'react-router-dom'
import ReactDOM from "react-dom";
import {createStore} from 'redux'
import {connect, Provider} from 'react-redux'

import update from "immutability-helper/index";
import {DragDropContext} from "react-beautiful-dnd";
import FetchWP from './utils/fetchWP';
import rootReducer from './reducers'
import {insertField, insertSection, resetFields, updateSection} from './actions'
import {newElementId, sectionKey} from './utils/newid'
import Canvas from "./canvas";
import Controls from "./controls";
import SaveChanges from './components/SaveChanges'
import FieldSettings from './FieldSettings'

import style from './backend.scss'
import AddNewSection from './components/addNewSection'
import {defaultFieldAttrs, fieldDefinitions, findFieldById, sectionCopy} from './schema'
import Sections from "./sections";
import ResetAll from "./resetAll";
import SettingsPage from "./settings";


const store = createStore(rootReducer)
// const store = createStore(
//     rootReducer, /* preloadedState, */
//     +window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );


class App extends React.Component {


    duplicateSection = key => {
        const {reduxFields} = this.props;
        const sectionId = sectionKey();
        // const newSection = sectionCopy(reduxFields[key]);
        const newSection = sectionCopy(reduxFields[key], sectionId);
        newSection.extra.key = sectionId;
        newSection.extra.section_id = sectionId;
        const updatedFields = {
            [sectionId]: newSection
        }
        this.props.dispatch(insertSection(updatedFields));
    }

    deleteSection = key => {
        const {reduxFields} = this.props;
        delete reduxFields[key];
        this.props.dispatch(insertSection(reduxFields));
    }

    addNewSection = (action = 'add', section = false) => {
        if (section === false) {
            const sectionId = sectionKey();

            const updatedFields = {
                [sectionId]: {
                    "extra": {
                        'key': sectionId,
                        'section_id': sectionId,
                        "name": "New Section",
                        "status": -1,
                        "enableSec": 1,
                        "sec_Order": 1,
                        "custom": true
                    },
                    "fields": []
                }
            }
            this.props.dispatch(insertSection(updatedFields));

            this.setState((prevState) => ({
                ...prevState,
                addNewSection: true,
                editSection: updatedFields[sectionId].extra
            }))
        } else {
            this.setState((prevState) => ({
                ...prevState,
                addNewSection: true,
                editSection: section
            }))
        }


    }

    closePopup = () => {
        this.setState((prevState) => ({
            ...prevState, addNewSection: false
        }))
    }

    changeTab = (tab) => {
        this.setState((prevState) => ({
            ...prevState, currentTab: tab
        }))
    }
    handleSectionChange = (field, index) => {
        const updatedFields = {[field.key]: {...update(this.props.reduxFields[field.key], {extra: {$set: field}})}}
        this.props.dispatch(insertSection(updatedFields))
        this.setState((prevState) => ({
            ...prevState,
            editSection: updatedFields[field.key].extra
        }))
    }

    handleFieldChange = (field, secKey) => {
        const {reduxFields, dispatch} = this.props;
        let names = [];
        let flag = true;
        Object.keys(reduxFields).forEach((sectionKey) => {
            reduxFields[sectionKey].fields.forEach(row => {
                row.forEach(f => {

                    if (typeof field.name !== 'undefined' && !field.name.startsWith(secKey+'_') && field.custom !== false ) {
                        field.error = {name: wp.i18n.__("Name must start with ")+(secKey+'_')}
                        flag = false;
                        return false;
                    }
                    if (typeof field.name !== 'undefined' && typeof f.name !== 'undefined' && field.elementId !== f.elementId && field.name === f.name) {
                        field.error = {name: wp.i18n.__("Name must be unique")};
                        flag = false;
                        return false;
                    }
                    if (typeof field.name !== 'undefined' && field.name === '') {
                        field.error = {name: wp.i18n.__("Name field is required!")};
                        flag = false;
                        return false;
                    }
                    return flag;
                })
                return flag;
            })
            return flag;
        })
        if (flag) {
            delete  field.error;
        }
        const {row, col} = findFieldById(field.elementId, reduxFields[secKey].fields)
        if (row !== false) {
            // check if the name field has changed
            if (reduxFields[secKey].fields[row][col].name !== field.name) {
                delete field.nameAutoUpdate;
            }
            if (typeof field.nameAutoUpdate !== 'undefined' && field.nameAutoUpdate === true) {
                field.name = secKey + "_" + field.label.toLowerCase()
                    .replace(/[^\w ]+/g, '')
                    .replace(/ +/g, '_');
            }
            const updatedFields = {[secKey]: {...update(reduxFields[secKey], {fields: {[row]: {[col]: {$set: field}}}})}}
            dispatch(insertField(updatedFields))

        }


    }

    SaveChanges = () => {
        const {reduxFields, dispatch} = this.props;
        this.setState((prevState) => ({
            ...prevState,
            saving: true
        }))
        const fieldsToSave = {};

        const sectionKeys = Object.keys(reduxFields).filter(key => {
            return reduxFields[key].extra.status && reduxFields[key].extra.status !== -1;
        });

        let names = [];

        let isValid = true;

        Object.keys(reduxFields).forEach((sectionKey) => { // read default fields names first to compare with other
            reduxFields[sectionKey].fields.forEach(row => {
                row.forEach(f => {
                    if (typeof f.name !== 'undefined' && f.custom === false) {
                        names.push(f.name)
                    }
                })
            })
        })


        for (let i = 0; i < sectionKeys.length; i++) {
            const key = sectionKeys[i];
            fieldsToSave[key] = {extra: {}, fields: []}

            let isSectionValid = true;

            let priority = 10;
            fieldsToSave[key].fields = [...reduxFields[key].fields.map((a) => {

                return a.map(f => {
                    priority += 10;
                    let error = {};
                    delete f.error;

                    if (typeof f.name !== 'undefined' && !f.name.startsWith(key+'_') && f.custom !== false ) {
                        error = {error: {name: wp.i18n.__("Name must start with ")+(key+'_')}};
                        isValid = false;
                        isSectionValid = false;
                    }
                    if (typeof f.name !== 'undefined' && names.indexOf(f.name) !== -1 && f.custom === true) {
                        error = {error: {name: wp.i18n.__("Name must be unique")}};
                        isValid = false;
                        isSectionValid = false;
                    }
                    if (typeof f.name !== 'undefined' && f.name === '') {
                        error = {error: {name: wp.i18n.__("Name field is required")}};
                        isValid = false;
                        isSectionValid = false;
                    }
                    if (typeof f.name !== 'undefined' && f.custom === true) {
                        names.push(f.name)
                    }
                    return {...f, "priority": priority, ...error}
                });
            })];

            fieldsToSave[key].extra = {...reduxFields[key].extra, error: isSectionValid ? false : true};
        }
        dispatch(updateSection(fieldsToSave));
        if (isValid === false) {
            this.setState((prevState) => ({
                ...prevState,
                saving: false,
                errorMessage: wp.i18n.__('Fix the errors shown for fields')
            }))
            setTimeout(() => {
                this.setState((prevState) => ({
                    ...prevState,
                    errorMessage: false
                }))
            }, 5000);
        } else {
            this.fetchWP.post('save', {'fields': fieldsToSave}).then(json => {
                // window.location = json;
                this.setState((prevState) => ({
                    ...prevState,
                    saving: false
                }))
            }).catch(error => {
                alert("Some thing went wrong");
            })
        }


    }

    switchEditorOpenTabs = (key) => {
        let {editorOpenTabs} = this.state;
        if (editorOpenTabs.indexOf(key) === -1) {
            // editorOpenTabs.push(key);
            editorOpenTabs = [key];
        } else {
            editorOpenTabs.splice(key, 1);
        }
        this.setState((prevState) => ({
           ...prevState, editorOpenTabs
        }));
    }

    onDragStart = start => {
        // console.log(start)
        const droppableSource = start.source.droppableId.split('-');
        const draggable = start.draggableId.split('-'); // {`column-${field.col}-${field.elementId}`}
        const {reduxFields} = this.props;
        if (droppableSource[1] && droppableSource[1] === "row" && draggable.length >= 3) {

            // const {field} = findFieldById(start.draggableId, reduxFields[section].fields)
            const dragItemId = draggable.slice(-(draggable.length - 2)).join("-");
            this.setState((prevState) => ({
                ...prevState,
                isColDraging: true,
                dragItemCol: parseInt(draggable[1]),
                dragSourceRowId: start.source.droppableId,
                dragItemId
            }));
        } else if (droppableSource[0] === "fields") {
            this.setState((prevState) => ({
                ...prevState,
                isColDraging: true,
                dragItemCol: 1,
                dragItemId: false,
                dragSourceRowId: false
            }));
        }
    }

    onDragEnd = result => {
        // dropped outside the list
        const {reduxFields, dispatch} = this.props;
        this.setState((prevState) => ({
            ...prevState,
            isColDraging: false,
            dragItemCol: 6,
            dragItemId: false

        }));
        if (!result.destination) {
            return;
        }
        let updatedFields = {...reduxFields};
        let temp = {};
        if (result.type === 'sections') {


            let newar = Object.entries(updatedFields);
            temp = newar.splice(result.source.index, 1);
            newar.splice(result.destination.index, 0, temp[0]);
            updatedFields = newar.reduce((obj, [k, v]) => ({...obj, [k]: v}), {})
            dispatch(updateSection(updatedFields))
            return;
        }

        const droppableDestinatin = [...result.destination.droppableId.split('-')];
        const droppableSource = [...result.source.droppableId.split('-')];
        let sourceRow = 0;
        let destinationRow = 0;

        if (droppableDestinatin[0] && result.destination) {
            const sectionD = droppableDestinatin[0];
            const sectionS = droppableSource[0];
            const draggable = result.draggableId.split('-');
            // console.log(draggable)
            if (draggable[0] === 'row') {
                sourceRow = result.source.index;
                destinationRow = result.destination.index;
                temp = updatedFields[sectionS].fields[sourceRow];
                updatedFields[sectionS].fields.splice(sourceRow, 1);
                updatedFields[sectionD].fields.splice(destinationRow, 0, temp);


            }
            // else if (droppableDestinatin[1] === "row" || droppableDestinatin[1] === "placeholder") {
            else {


                if (droppableDestinatin[1] === 'canvas') {
                    destinationRow = result.destination.index;
                } else {
                    destinationRow = droppableDestinatin[2] ? droppableDestinatin[2] : 0;
                }


                if (draggable[0] === 'column') {
                    sourceRow = droppableSource[2];
                    if (sourceRow === destinationRow && result.destination.index === result.source.index) {
                        return;
                    }
                    temp = updatedFields[sectionS].fields[sourceRow][result.source.index];
                    updatedFields[sectionS].fields[sourceRow].splice(result.source.index, 1);
                    if (updatedFields[sectionS].fields[sourceRow].length === 0) {
                        updatedFields[sectionS].fields.splice(sourceRow, 1)
                    }
                } else {
                    temp = {...fieldDefinitions(draggable[1], sectionD), nameAutoUpdate: true};

                    temp.col = (droppableDestinatin[1] === "row") ?
                        (6 - updatedFields[sectionD].fields[destinationRow].reduce((a, b) => a + b.col, 0)) : 6;
                }


                // updated_fields[this.props.section].fields.push(field_definitions[item.field.key])
                if (droppableDestinatin[1] === "row") {

                    updatedFields[sectionD].fields[destinationRow].splice(result.destination.index, 0, temp);
                } else {
                    updatedFields[sectionD].fields.splice(destinationRow, 0, [temp]);
                }


            }


            // updated_fields[this.props.section].fields.splice(dragIndex+1, 0, updated_fields[this.props.section].fields[dragIndex]);

            dispatch(insertField(updatedFields))
        }


    }
    onScroll = () => {


        requestAnimationFrame(() => {
            const {stickySection} = this.state;
            const top = this.stickySection.current.getBoundingClientRect().top;
            if (top < 32 && stickySection === false) {
                this.setState({
                    stickySection: true,
                });
            } else if (top > 32 && stickySection === true) {
                this.setState({
                    stickySection: false,
                });
            }
        })
    }

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            awcfePageLoader: true,
            fields: [],
            addNewSection: false,
            currentTab: 'fields', // or settings
            editorOpenTabs: ['general'],
            isColDraging: false,
            dragSourceRowId: false,
            dragItemCol: 6,
            dragItemId: false,
            saving: false,
            errorMessage: false,
            stickySection: false,
            tempKey: '',
            awcfeObject: window.awcfe_object
        }
        this.stickySection = React.createRef();
        this.fetchWP = new FetchWP({
            restURL: window.awcfe_object.root,
            restNonce: window.awcfe_object.api_nonce,
            isMlActive: window.awcfe_object.isMlActive,
            ml: window.awcfe_object.isMlActive ? window.awcfe_object.ml : false
        });

    }

    componentDidUpdate(prevProps) {


    }

    componentDidMount() {
        this.fetchFields();

        window.addEventListener("resize", this.onResize);
        window.addEventListener("scroll", this.onScroll);

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }

    fetchFields() {
        this.setState({
            loader: true,
            awcfePageLoader: true,
        });


        this.fetchWP.get('fields/')
            .then(
                (json) => {
                    const data = {};
                    Object.keys(json).forEach(function (key) {
                        // json[key].fields.push({
                        //     "type": "dndholder",
                        //     "col": 6
                        // })
                        let col = 0;
                        const rows = []
                        let cols = []
                        // row.push(<div className={style.row}></div>)
                        json[key].fields.map((row, i) => {
                            row.map(col => {
                                if (typeof col.elementId === 'undefined' || col.elementId === '' || col.elementId == null) {
                                    let id = newElementId();
                                    col.elementId = col.type + '-' + id;
                                }

                            })

                        })

                        //data[key] = {...json[key], fields: rows};


                    });

                    // console.log(data);

                    this.props.dispatch(resetFields(json));

                    this.setState({tempKey: 1})
                    this.setState({ awcfePageLoader: false, });
                });

        // this.setState({
        //     fields: dummy_json,
        // });

    }

    render() {
        const {currentTab, editorOpenTabs, dragItemCol, dragItemId, isColDraging, dragSourceRowId, saving, stickySection, errorMessage, awcfeObject} = this.state;
        // console.log(isColDraging);

        return (
            <div className={style.wrapper}>

            {(awcfeObject.isMlActive && awcfeObject.ml.isDefault === false) &&
                <div className={style.mlWarning} dangerouslySetInnerHTML={{__html: wp.i18n.__('You are currently not in default Language, so this editor can use only for translating <b>Labels, Values, Help Text, and Place holder value</b>. All other configurations and parameters will be populating from default language' +
                    '\n')}} /> }
                <div className={style.header}>
                    <h3>{wp.i18n.__('Build Your Form')}</h3>
                    <div className={style.submitActions}>
                        {errorMessage && <div>{errorMessage}</div>}

                        <div className={style.sb_wrap}>
                          <a className={style.settings_button} href={window.awcfe_object.settings_url}>{wp.i18n.__('Settings')}</a>
                        </div>

                        <ResetAll />

                        <SaveChanges saving={saving} SaveChanges={this.SaveChanges}/>
                    </div>
                </div>

              {this.state.awcfePageLoader != false ? (
                <div id="awcfe_page_loader"></div>
              ) : (
                ''
              )}

                <div className={style.navSection}>
                    <HashRouter>
                        <Switch>
                            <Route
                                path="/section/:sectionId?/:fieldId?"
                                render={props =>
                                    <Sections
                                        {...props}
                                        addNewSection={this.addNewSection}
                                        duplicateSection={this.duplicateSection}
                                        deleteSection={this.deleteSection}
                                    />}
                                    />}
                            />
                        </Switch>
                    </HashRouter>
                </div>

                <div className={style.canvCtlWrap}>

                    <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>

                        <div className={style.canvasSection}>


                            <HashRouter>

                                <Switch>

                                    <Route
                                        path="/"
                                        exact
                                        render={props =>
                                            <Redirect from="/" to="/section/billing"/>

                                        }
                                    />
                                    <Route
                                        path="/section/:sectionId/:fieldId?"
                                        render={props =>
                                            <Canvas
                                                addNewSection={this.addNewSection}
                                                duplicateSection={this.duplicateSection}
                                                deleteSection={this.deleteSection}
                                                changeTab={this.changeTab}
                                                matchParams={props.match.params}
                                                dragItemCol={dragItemCol}
                                                isColDraging={isColDraging}
                                                dragSourceRowId={dragSourceRowId}
                                                dragItemId={dragItemId}
                                                key={props.match.params.sectionId + this.state.tempKey || 'empty'}
                                            />}
                                    />

                                </Switch>

                            </HashRouter>

                        </div>


                        <div className={style.controllerSection} ref={this.stickySection}>
                            <div className={(stickySection && style.stickyLeft)}>
                                <ul className={style.ctlTabs}>
                                    <li className={currentTab === 'fields' ? style.active : ''} onClick={() => {
                                        this.changeTab('fields')
                                    }}>
                                        <span>{wp.i18n.__('Fields')}</span>
                                    </li>
                                    <li className={currentTab === 'options' ? style.active : ''} onClick={() => {
                                        this.changeTab('options')
                                    }}>
                                        <span>{wp.i18n.__('Options')}</span>
                                    </li>
                                </ul>
                                {currentTab === 'fields' &&
                                <Controls/>}
                                <HashRouter>
                                    <Switch>

                                        <Route
                                            path="/"
                                            exact
                                            render={props =>
                                                <FieldSettings
                                                    editorOpenTabs={editorOpenTabs}
                                                    switchTab={this.switchEditorOpenTabs}
                                                    openSettings={this.changeTab}
                                                    currentTab={currentTab}
                                                    key={props.match.params.id || 'empty'}
                                                    handleChange={this.handleFieldChange} {...props}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/section/:sectionId/:fieldId"
                                            render={props => {

                                                return <FieldSettings
                                                    editorOpenTabs={editorOpenTabs}
                                                    switchTab={this.switchEditorOpenTabs}
                                                    openSettings={this.changeTab}
                                                    currentTab={currentTab}
                                                    key={props.match.params.fieldId || 'empty'}
                                                    handleChange={this.handleFieldChange} {...props}
                                                />
                                            }
                                            }
                                        />

                                    </Switch>

                                </HashRouter>
                            </div>

                        </div>



                    </DragDropContext>
                </div>
                {this.state.addNewSection ?
                    <AddNewSection
                        section={this.state.editSection}
                        key={this.state.editSection ? this.state.editSection.key : false}
                        handleChange={this.handleSectionChange} closePopup={this.closePopup}/> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let reduxFields = {fields: []};
    if (typeof  state.fields.data !== "undefined") {
        reduxFields = state.fields.data
    }
    return {
        reduxFields,
        version: typeof state.fields.version !== "undefined" ? state.fields.version : 0
    }
}
const ConnectedApp = connect(mapStateToProps)(App)
const Index = (props) => {
    return (<Provider store={store}>
            <ConnectedApp/>
        </Provider>
    )
};
const Settings = (props) => {
    return (<HashRouter  >
        <div className="awcfe_content">
                <div className="awcfe_actions clearfix">
                <div className={style.mainclass}>
                        <h1 className={style.main_title} > {wp.i18n.__('WooCommerce Checkout Field Editor and Manager')} </h1>          
                        <a href="admin.php?page=awcfe_admin_ui#/" className={style.title_button} >{wp.i18n.__('Checkout Fields')} </a> 
                    </div>
                </div>
            <Switch>
                <Route
                    path="/"
                    render={props =>
                        <SettingsPage
                            {...props}
                        />}
                />
            </Switch>
        </div>
    </HashRouter >)
};
if (document.getElementById("awcfe_ui_root")) {
    ReactDOM.render(<Index wpObject={window.awcfe_object}/>, document.getElementById("awcfe_ui_root"));
}
if (document.getElementById("awcfe_admin_settings")) {
    ReactDOM.render(<Settings wpObject={window.awcfe_object}/>, document.getElementById("awcfe_admin_settings"));
}
